import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { apiClient } from "../../lib/api";

const beep = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.frequency.value = 880; g.gain.value = 0.08; o.connect(g); g.connect(ctx.destination);
    o.start(); o.stop(ctx.currentTime + 0.25);
    return ctx.state === "running";
  } catch { return false; }
};

// Polls pending import authorization requests; visual + sound alert, title badge as fallback.
export function ImportRequestAlert({ ar, onOpen }) {
  const last = useRef(null);
  const baseTitle = useRef(document.title);
  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const { data } = await apiClient.get("/admin/imports/authorizations", { params: { status: "pending_review" } });
        if (!alive) return;
        const n = (data.items || []).length;
        document.title = n ? `(${n}) ${baseTitle.current}` : baseTitle.current;
        if (last.current !== null && n > last.current) {
          const sound = beep();
          toast(ar ? `طلب تفويض استيراد جديد (${n} بانتظار المراجعة)` : `New import authorization request (${n} pending)`,
            { description: sound ? undefined : (ar ? "فعّل الصوت في المتصفح لسماع التنبيه" : "Enable sound in the browser to hear alerts"),
              action: { label: ar ? "فتح" : "Open", onClick: onOpen }, duration: 15000 });
        }
        last.current = n;
      } catch { /* permission or network — silent */ }
    };
    check();
    const t = setInterval(check, 20000);
    return () => { alive = false; clearInterval(t); document.title = baseTitle.current; };
  }, [ar, onOpen]);
  return null;
}
